import { ProviderType } from '../models/project-integration.model';

/**
 * Single source of truth for how each issue-tracker provider is presented in the
 * UI (label, brand color, badge glyph). Colors reference the theme tokens
 * (`--to-jira`, `--to-redmine`) so they stay consistent across the picker, the
 * requirement card and the project form. Used both in templates
 * (`[style.background]`) and TS.
 */
export interface ProviderMeta {
  label: string;
  color: string;
  /** Short text mark for the provider badge; `null` when the provider has its own logo. */
  glyph: string | null;
  /**
   * Ob der Anbieter das Anlegen eines Vorgangs beherrscht. Der Server antwortet
   * andernfalls mit 501 — ein solches Ziel gehoert nicht in eine Auswahl, die dem
   * Anlegen dient.
   */
  supportsIssueCreation: boolean;
}

export const PROVIDER_META: Record<ProviderType, ProviderMeta> = {
  JIRA: { label: 'Jira', color: 'var(--to-jira, #0052cc)', glyph: null, supportsIssueCreation: true },
  REDMINE: { label: 'Redmine', color: 'var(--to-redmine, #b32024)', glyph: 'RM', supportsIssueCreation: true },
  GITHUB: { label: 'GitHub', color: 'var(--to-github, #1f2328)', glyph: 'GH', supportsIssueCreation: false },
};

export function providerLabel(provider: ProviderType): string {
  return PROVIDER_META[provider]?.label ?? provider;
}

export function providerColor(provider: ProviderType): string {
  return PROVIDER_META[provider]?.color ?? 'var(--to-brand)';
}

export function providerSupportsIssueCreation(provider: ProviderType): boolean {
  return PROVIDER_META[provider]?.supportsIssueCreation ?? false;
}

export function providerGlyph(provider: ProviderType): string | null {
  const meta = PROVIDER_META[provider];
  return meta ? meta.glyph : provider.slice(0, 2).toUpperCase();
}
